export default ({keys, server}) => `package com.stripe.example

import com.stripe.stripeterminal.callable.TerminalListener
import com.stripe.stripeterminal.model.external.Reader

class TerminalEventListener : TerminalListener {
    override fun onUnexpectedReaderDisconnect(reader: Reader) {
        // Show UI that your reader disconnected
    }
}
`;
